import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialog from "./../../factories/bao-dialog";
import WorkItemViewModel from "../work-item";
import WorkItemSerialDialogViewModel from "./work-item-serial-dialog-view-model";

/*
 * View of dialogue model responsible for serial task
 * */
class WorkItemSerialDialog {

    // #region Constructor

    /**
     * Constructor
     * @param parent The parent view model
     */
    constructor(parent: WorkItemViewModel) {
        this.Parent = parent;
        this.Dialog = new BaoDialog(Bao.Session.ApplicationName);
        this.Dialog.Width(900);
        this.Dialog.Buttons([
            {
                Title: Bao.Session.GetMessage("msgOk"),
                    Click: () => {
                        this.Parent.SerialDialogCompleteCheck(this.DialogViewModel, false).then((valid) => {
                            if (valid) {
                                this.DialogResult(ko.map.toJS(this.DialogViewModel));
                            this.Dialog.Close();
                        }
                    });
                },
                Enabled: ko.observable(true)
            },
            {
                Title: Bao.Session.GetMessage("msgCancel"),
                Click: () => {
                    this.Dialog.Close();
                },
                Enabled: ko.observable(true)
            }
        ]);
    }

    // #endregion

    // #region Properties

    /** Bao  */
    Bao = Bao;
    /** Default dialog */
    Dialog: BaoDialog;
    /** The parent view model */
    Parent: WorkItemViewModel;
    /** Dialog view model */
    DialogViewModel: WorkItemSerialDialogViewModel = new WorkItemSerialDialogViewModel();
    /** Result from dialog */
    DialogResult = ko.observable();
    /** True if the dialog is displayed */
    DialogShown: boolean = false;
    /** Id of ShiftbookTab */
    ShiftbookTabId: KnockoutObservable<string> = ko.observable("");

    // #endregion

    // #region Public Methods

    /**
     * Function used to display dialog
     * @returns JQueryPromise<void>
     */
    Show(): JQueryPromise<void> {
        let def = $.Deferred();
        this.Dialog.Open();
        this.Dialog.IsLoading(true);
       
        Bao.post("WorkItemRecurring/ShowWorkItemSerialDialog", JSON.stringify({
            workItemId: this.Parent.WorkItemId()
        }), (value) => {
            if (this.Parent.SerialTaskDialogViewModel) {
                this.DialogViewModel = ko.map.fromJS(ko.toJS(this.Parent.SerialTaskDialogViewModel));
            }
            else {
                ko.map.fromJS(value.Model, this.DialogViewModel, ko.dirtyFlag());
                if (this.DialogViewModel.IsNew()) {
                    this.DialogViewModel.EndTimeJs(this.Parent.EndDateHtml());
                }
            }
            
            this.SetSubscriptionValues();
            this.InitEndOptionValue();
        
            if (ko.unwrap(this.DialogViewModel.SelectedDays) === null) {
                this.DialogViewModel.SelectedDays = ko.observableArray([]);
            }
                           
            this.Dialog.ViewModel(this.DialogViewModel);
            this.Dialog.Template(value.Message);
        })
        .always(_ => {
            this.DialogShown = true;
            this.Dialog.IsLoading(false);
            def.resolve();
         });

        return def.promise();
    }


    // #endregion

    // #region Protected Methods

    /** Initializes the end option value */
    protected InitEndOptionValue = () => {
        if (this.DialogViewModel.EndTimeJs()) {
            this.DialogViewModel.EndOptionValue('1');
        }
        else if (this.DialogViewModel.NumberOfOccurrences() > 0) {
            this.DialogViewModel.EndOptionValue('2');
        }
        else {
            this.DialogViewModel.EndOptionValue('3');
        }
    }

    /** Handle subscriptions on properties */
    protected SetSubscriptionValues = () => {
        this.DialogViewModel.EndOptionValue.subscribe((value: string) => {
            if (this.DialogShown) {
                if (value !== '1') {
                    this.DialogViewModel.EndTimeJs(null);
                }
                if (value !== '2') {
                    this.DialogViewModel.NumberOfOccurrences(null);
                }
            }
        });
        this.DialogViewModel.RecurringType.subscribe((value: string) => {
            if (this.DialogShown) {
                if (value == 'monthly' || value == 'yearly') {
                    this.DialogViewModel.SelectedOption('1');
                }
                else {
                    this.DialogViewModel.SelectedOption(null);
                }
            }
        });
    }

    // #endregion
}
export default WorkItemSerialDialog;